import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-income-details',
  templateUrl: './income-details.component.html',
  styleUrl: './income-details.component.scss'
})
export class IncomeDetailsComponent {
  model!: FormGroup;
  fileSelected: boolean = false;
  base64File: string = '';
  fileExtension: string = '';

  constructor(private fb: FormBuilder, private finzyService: FinzyService, private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.spinner.hide()
    this.model = this.fb.group({
      documentType: ['', Validators.required],
      file: [null, Validators.required]
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    this.model.patchValue({ file: event.target.files[0], documentType: 'ITR' });

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      alert('Only PDF, JPG, JPEG, or PNG files are allowed.');
      this.fileSelected = false;
      return;
    }

    this.fileExtension = file.name.split('.').pop()!;
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = (reader.result as string).split(',')[1];
      this.base64File = base64String;
      this.fileSelected = true;
    };

    reader.readAsDataURL(file);
  }

  async submit(): Promise<void> {
    if (this.model.invalid || !this.fileSelected) {
      this.spinner.hide();
      return;
    }

    this.spinner.show();
    const payload = {
      documentType: "ITR",
      docType: "IncomeProof",
      extension: this.fileExtension,
      currentAddressProofBase64: this.base64File,
    };

    try {
      var res = await lastValueFrom(this.finzyService.UploadDocuments(payload));
      if (res['data'] === 'success') {
        this.router.navigateByUrl('/assist-journey/f/bank-info');
      }
    } catch (err) {
      this.spinner.hide();
      if (err?.status === 401) {
        this.router.navigateByUrl('/assist-journey/session-expired');
      }

      if (err.status === 0) {
        swal.fire('Error', 'Network error, please check your internet connection and try again.');
        return;
      }
    }
    console.log(res);
  }
}
